module.exports = __webpack_public_path__ + "img/電気回路_5_10.a65d4b5c.png";